module.exports = __webpack_public_path__ + "img/pause.165db51c.png";